import { Modal } from '@wyz/ui';
import { PdfViewer } from '~/common/components';
/* eslint-disable-next-line @wyz/module/no-relative-import */
import { PdfViewerProps } from './pdf-viewer';

type Props = {
  onClose: () => void;
} & PdfViewerProps;

function PdfModal({ onClose, ...pdfViewerProps }: Props) {
  return (
    <Modal.Container onClose={onClose} open={true} size='lg'>
      <Modal.Body>
        <PdfViewer {...pdfViewerProps} />
      </Modal.Body>
    </Modal.Container>
  );
}

export default PdfModal;
